<div id="modalBodyDiagrammeNoteViewer" class="modal-body" style="padding: 0px;width: 100%; height: 100%;">
  <div id="divRowDiagrammeNoteViewer" class="tc">
      <iframe [src]="pathUrl"  style="width: 100vw; height:100vh;" class="tc"></iframe>
      <!-- <iframe [src]="pathUrl" [width]="screenWidth" [height]="screenHeight" class="tc"></iframe> -->
  </div>
</div>
